import React from 'react';
import { Box, Container, Link, Stack, Typography } from '@mui/material';

const AppFooter = () => {
  return (
    <Box component="footer" sx={{ borderTop: '1px solid', borderColor: 'divider', mt: 3, py: 1.5, bgcolor: 'background.paper' }}>
      <Container maxWidth="lg">
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={0.5} alignItems="center" justifyContent="space-between">
          <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
            Vehicle Management System
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Powered by{' '}
            <Link href="https://pinetechs.com/" target="_blank" rel="noopener" underline="hover">
              pinetechs.com
            </Link>
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
};

export default AppFooter;
